{
  "en": {
    "milestone": {
      "actions": {
        "activate": "Activate",
        "activate_phase": "Activate this phase",
        "complete_phase": "Complete this phase",
        "create": "Create phase",
        "delete": "Delete",
        "delete_milestones": "Delete phase | Delete {count} phases",
        "move_down": "Move phase down",
        "move_unit_back": "Move unit back to here",
        "move_up": "Move phase up",
        "new": "Phase",
        "reactivate_phase": "Reactivate this phase"
      },
      "activate": {
        "body": "Every item of this phase is published for this unit and its assignees are notified.",
        "body_empty": "Makes nothing visible to the customer.",
        "body_intermediate": "Phases in between are completed as well, and every item attached to them is published too.",
        "body_project": "Every item of this phase is published for this project and its assignees are notified.",
        "body_reactivate": "This phase becomes the current one again. Nothing is withdrawn: everything already published or sent stays in place. The phases after it become planned again.",
        "confirm": "Activate",
        "confirm_publish": "Activate and send",
        "confirm_reactivate": "Reactivate",
        "past_warning": "Going back to an earlier phase won't undo what already happened. Anything shared with customers will not automatically be revoked.",
        "title": "Activate phase",
        "title_activate": "Activate “{name}”?",
        "title_reactivate": "Reactivate “{name}”?",
        "verb_default": "Trigger",
        "verb_share": "Share"
      },
      "assign": {
        "body": "The units you select move to “{to}”. The items of “{to}”, and of any phase they skip, become visible to the customer and the assignees are notified.",
        "body_phases_only": "The units you select move to “{to}”. The customer sees the new phase.",
        "excluded": "Units already on or past “{to}” can't be selected."
      },
      "attach": {
        "add": "Add",
        "add_and_move": "Add and move",
        "assigned_tag": "Assigned",
        "back": "Back",
        "counts": "{available} available · {assigned} already assigned",
        "description_decision": "Decisions the customer has to make",
        "description_survey": "Questionnaires to collect input",
        "description_todo": "Tasks the customer has to complete",
        "elsewhere_tag": "Now on {name}",
        "empty": "No items available",
        "empty_state_description": "Based on your plan you can add {kinds} to this phase.",
        "intro": "Choose which type of item you want to link to this phase.",
        "move_notice_body": "Anything already sent stays sent. The old phase loses this item.",
        "move_notice_item": "{element}, now on {phase}",
        "move_notice_title": "This item moves to “{name}” | These items move to “{name}”",
        "next": "Next",
        "search": "Search",
        "select_intro": "Select the {kind} you want to add.",
        "subtitle": "To phase: {name}",
        "success": "Items added",
        "title": "Add items"
      },
      "complete_phase": {
        "body": "This unit completes this phase and is left without an active phase. | {count} units complete this phase and are left without an active phase.",
        "body_sup": "This project completes this phase and is left without an active phase.",
        "confirm": "Complete phase",
        "keep": "Keep phase active",
        "title": "Complete “{name}”?"
      },
      "delete_phase": {
        "body": "Units on this phase will be left without an active phase. They are not moved to the previous or next step. The items of this phase are detached, not deleted. Items already published to a unit stay published: you remove those on the unit itself.",
        "body_last": "Units on this phase will be left without an active phase. Because this is the last phase, they then count as completed. The items of this phase are detached, not deleted. Items already published to a unit stay published: you remove those on the unit itself.",
        "body_sup": "This project will be left without an active phase. It is not moved to the previous or next step. The items of this phase are detached, not deleted. Items already published stay published: you remove those on the project itself.",
        "confirm": "Delete phase",
        "keep": "Keep phase",
        "title": "Delete “{name}”?"
      },
      "detach": {
        "body": "This takes the item off this phase. The item itself keeps existing and units that already saw it keep it. New units no longer receive it at this phase.",
        "confirm": "Detach",
        "keep": "Keep",
        "title": "Detach “{name}”?"
      },
      "filters": {
        "clear": "Clear all filters",
        "done": "Done",
        "group_milestones": "Phases",
        "group_status": "Status",
        "group_title": "Phase contents",
        "no_phase": "No phase",
        "no_units_here": "No units here",
        "nothing_assigned": "Nothing assigned",
        "phase_last": "On final phase",
        "since_month_over": "Longer than a month",
        "since_quarter_over": "Longer than 3 months",
        "since_two_weeks_over": "Longer than 2 weeks",
        "title": "Filters",
        "units_here": "Has units here"
      },
      "labels": {
        "add_element": "Add item",
        "assign_units": "Assign units",
        "assigned_count": "0 assigned | 1 assigned | {count} assigned",
        "assigned_elements": "Assigned items",
        "assigned_empty_description": "Attach {kinds} to this phase",
        "assigned_empty_title": "No items yet",
        "bulk_assign_title": "Select units you want to assign phase '{milestone_name}' to",
        "complete_units": "Complete {count} unit | Complete {count} units",
        "completed_subtitle": "These units have been through the workflow",
        "completed_title": "Completed",
        "detach": "Detach",
        "detach_element": "Detach {name}",
        "drag_to_reorder": "Drag to reorder",
        "edit_milestone": "Edit phase",
        "element_count": "{count} item | {count} items",
        "elements_assign_link": "Assign items in Workflows",
        "elements_attached": "{elements} attached",
        "elements_empty": "No items are attached to this phase yet.",
        "kind_decision": "Decision | Decisions",
        "kind_decision_count": "{count} decision | {count} decisions",
        "kind_survey": "Survey | Surveys",
        "kind_survey_count": "{count} survey | {count} surveys",
        "kind_todo": "Task | Tasks",
        "kind_todo_count": "{count} task | {count} tasks",
        "locked_not_sent": "{count} element is locked by your plan and won't be sent. | {count} elements are locked by your plan and won't be sent.",
        "locked_tooltip": "Not included in your current plan. This won't be sent to customers.",
        "milestone": "Phase",
        "milestone_current": "Current phase",
        "milestone_name": "Phase name",
        "move_units_to": "Move {count} unit to {name} | Move {count} units to {name}",
        "new_milestone": "New phase",
        "no_results": "No phases found",
        "please_select": "Please select a new phase",
        "position": "Position",
        "progress": "Progress",
        "publishes_empty": "Nothing attached yet",
        "reorder_filtered": "Clear the search or filter to reorder phases",
        "search_empty_state": "No phases created yet. Click here to start",
        "search_phase": "Search phase",
        "search_unit": "Search unit",
        "search_units": "Search units",
        "since": "Since",
        "started_on": "Started {date}",
        "status_active": "In progress",
        "status_completed": "Completed",
        "status_planned": "Planned",
        "unit_active_since": "In progress since {date}",
        "unit_completed_on": "Completed {date}",
        "unit_timeline_empty": "No phases have been created for this project yet.",
        "units": "Units",
        "units_completed": "No units completed | 1 unit completed | {count} units completed",
        "units_empty": "No units have reached this phase yet.",
        "units_here": "No units here | 1 unit here | {count} units here",
        "units_no_results": "No units found",
        "unstarted_subtitle": "These units have no active phase",
        "unstarted_title": "Not on a phase",
        "view_phases": "Phases",
        "view_units": "Units",
        "warning_delete": "If you delete a phase that has been assigned to a unit, the customer will lose sight of what phase their unit is at. Be sure to assign a new phase to these units!"
      },
      "move": {
        "body": "This unit moves from “{from}” to “{to}”. The items of “{to}” become visible to the customer and the assignees are notified. | These units move from “{from}” to “{to}”. The items of “{to}” become visible to the customer and the assignees are notified.",
        "body_phases_only": "This unit moves from “{from}” to “{to}”. The customer sees the new phase. | These units move from “{from}” to “{to}”. The customer sees the new phase.",
        "confirm": "Move and notify",
        "confirm_phases_only": "Move",
        "elements": "Makes {elements} visible to the customer",
        "title": "Move {count} unit to “{name}”? | Move {count} units to “{name}”?"
      },
      "overview": {
        "no_phase": "No phase",
        "not_started": "Not started",
        "since_date": "Since {date}",
        "step_of": "Step {step} of {total}"
      },
      "publication_failed": {
        "body": "Sending this phase's items failed for 1 unit. | Sending this phase's items failed for {count} units.",
        "retried": "The items are being sent again",
        "retry": "Send again"
      },
      "reorder": {
        "body_earlier": "Moving this phase earlier withdraws nothing that was already published. Units keep what they have; only the order changes.",
        "body_earlier_sup": "Moving this phase earlier withdraws nothing that was already published. The project keeps what it has; only the order changes.",
        "body_later": "Moving this phase later withdraws nothing that was already published. Units keep what they have; only the order changes.",
        "body_later_sup": "Moving this phase later withdraws nothing that was already published. The project keeps what it has; only the order changes.",
        "body_passed": "Units on a later phase now pass this phase. Everything attached to it is published to them right away.",
        "body_passed_sup": "This project now passes this phase. Everything attached to it is published right away.",
        "body_passes": "Units on this phase now pass the phases in between. Everything attached to those phases is published to them right away.",
        "body_passes_sup": "This project now passes the phases in between. Everything attached to those phases is published right away.",
        "confirm": "Move phase",
        "count": "{count} unit passes {phases} at once | {count} units pass {phases} at once",
        "count_sup": "This project passes {phases} at once",
        "crossed": "{name} ({elements})",
        "nothing": "nothing",
        "phases": "{count} phase | {count} phases",
        "title": "Place “{name}” after “{previous}”?",
        "title_first": "Place “{name}” first?"
      },
      "toasts": {
        "bulk_assigned": "The phase is successfully assigned to the selected units",
        "create_success": "Phase successfully created",
        "deleted": "Phase deleted",
        "phase_without_active_units": "There are no active units left to change",
        "phase_without_units": "No units are on this phase anymore",
        "sup_assigned": "The phase is successfully activated",
        "sup_completed": "Phase completed",
        "units_completed": "{count} unit completed | {count} units completed",
        "units_moved": "{count} unit moved | {count} units moved",
        "update_success": "Phases have been successfully updated"
      },
      "validation": {
        "needNamePrimary": "The primary language ({language}) name is required"
      }
    }
  }
}
